<template>
    <div id="chargeDetail1">
        <p class="chargeDetai_p1">收费详情</p>
        <div style="display: flex;flex-wrap: nowrap">
            <div class="infomation1">
                <div class="Headpic"><img :src="patientBaseEntity.image"></div>
                <div class="name1">{{patientBaseEntity.name}}</div>
                <div class="in-table1">
                    <div class="in-tabOne1"><h2>性别:<span>{{this.patientBaseEntity.gender}}</span></h2></div>
                    <div class="in-tabTow1"><h2>周岁:<span>{{patientBaseEntity.age}}</span></h2></div>
                </div>
                <div class="in-tel1"><h2>电&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;话:<span>{{this.patientBaseEntity.mobileNumber}}</span></h2></div>
                <div class="in-tel1"><h2>订单编号:<span>{{this.Data}}</span></h2></div>
            </div>
            <div class="list1">
                <p class="list_p1">收费信息</p>
                <template>
                    <el-table :data="tablevalue" style="width: 100%" border>

                        <el-table-column prop="recipeName" label="名 称" ></el-table-column>
                        <!--<el-table-column prop="retailPrice" label="单价"></el-table-column>-->
                        <el-table-column prop="quantity" label="数 量" ></el-table-column>
                        <!--<el-table-column prop="medicineUnit" label="单位"></el-table-column>-->
                        <el-table-column prop="totalCost" label="合 计" width="200"></el-table-column>

                    </el-table>

                </template>
                <div class="heji1">费用总合计：<span style="color: red">{{totalCost ? totalCost :'0.00'}} 元</span>
                      {{gift ? '赠送额度'+gift+'元' :''}}
                    <!--<el-input :class="{inputNum:active}" v-model="quantity" :disabled="true"></el-input>-->
                </div>
                <div class="dizhik" v-if="this.orderType==0 && !lookid">
                    <span style="color:dimgray">是否邮寄药品（不邮寄不用选）：</span>
                    <el-select v-model="levelSelected" clearable >
                        <el-option v-for="item in userLevelType" :key="item.value"
                                   :label="item.label"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                    <el-input style="width: 40%;" v-show="levelSelected=='是'" v-model="mailAddress"  :rows="2" placeholder="请输入邮寄地址"></el-input>
                </div>

                <div class="dizhik" v-if="isPayer"> 姓&nbsp;&nbsp;&nbsp;名：
                    <el-select v-model="Jname" filterable placeholder="请选择"  @change="changeValue">
                        <el-option
                                v-for="item in options"
                                v-if="item.isStock === '1'"
                                :key="item.index"
                                :label="item.overdraw ? item.name + ' 预存透支:'+item.overdraw : item.name + ' 预存额度:' + item.quota"
                                :value="item.id + '@' + item.quota">
                        </el-option>
                        <el-option
                                v-for="item in options"
                                v-if="item.isStock !== '1'"
                                :key="item.index"
                                :label="item.overdraw ? item.name + ' 额度透支:'+item.overdraw : item.name + ' 充值额度:' + item.quota"
                                :value="item.id + '@' + item.quota">
                        </el-option>
                    </el-select>
                </div>

                <div class="dizhik" v-if="mailAddress!=''" style="color:rgba(0, 0, 0, 0.68);">
                    邮寄地址：{{mailAddress}}
                </div>
                <div class="button1" v-if="this.$route.query.data">
                    <el-button type="primary" @click="pay(paymentType=0)" v-if="!isPayer">现金支付</el-button>
                    <el-button type="primary"  @click="pay(paymentType=2)" v-if="!isPayer">医保卡</el-button>
                    <el-button type="primary"  @click="pay(paymentType=3)" v-if="!isPayer">银行卡</el-button>
                   <!-- <el-button type="info"  v-if="!isPayer">微信支付</el-button>-->
                    <el-button type="danger"  @click="change()" v-if="!isPayer">余额支付</el-button>
                    <el-button type="danger"  @click="pay(paymentType=4)" v-if="isPayer">确认余额支付</el-button>
                    <el-button type="plain"  @click="change()" v-if="isPayer">取消余额支付</el-button>
                    <router-link to="./charge_list" v-if="!isPayer">
                        <el-button type="info" plain>取消</el-button>
                    </router-link>
                    <div class="tips" style="color:red;">
                        注：如需微信支付，请指导患者在公众号打开“我的订单->待支付订单”查看并支付！
                    </div>
                </div>
                <div class="button1" v-if="this.$route.query.Data">
                    <router-link to="./charge_list">
                        <el-button type="info" plain>返回</el-button>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<style type="text/css" scoped>
    .el-button--primary {
        color: #fff;
        background-color:  rgb(60, 110, 169);
        border-color: rgb(60, 110, 169);
    }
    .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
        color: #fff;
        background-color: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
    }
    .el-button--primary:focus, .el-button--primary:hover {
        background: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
        color: #fff;
    }
    .dizhik{
        margin-top:30px;
        padding-left: 20%;
    }
    .tips{
        margin-top:30px;
    }
    .inputNum {
        width: 100px;
    }
    .Headpic{
        width: 100px;
        height: 100px;
        margin-top: 8px;
        margin-left: 35%;
        border-bottom: 1px solid #e7e7e7;
        border-radius: 50%;
        overflow: hidden;
    }
    .Headpic img{
        width: 100%;
        height: 100%;
    }
    .button1 {
        margin-top:40px;
        padding-left: 20%;
    }

    #chargeDetail1 {
        width: 100%;
        padding-bottom: 50px;
        background-color: white;
        /*margin: 30px 20px;*/
    }

    .chargeDetai_p1 {
        padding-left: 18px;
        border-bottom: 1px solid #e7e7e7;
        font-size: 20px;
        color: #99a9bf;;
        line-height: 70px;
    }

    .infomation1 {
        width: 20%;
        height: 365px;
        border: 1px solid #dcdcdc;
        margin: 20px 15px;
        box-shadow: 0 0 10px #dcdcdc;
        border-radius: 10px;
    }

    .name1 {
        line-height: 50px;
        /*margin-top: 20px;*/
        text-align: center;
        border-bottom: 1px solid #dcdcdc;
        text-align: center;
    }

    .in-table1 {
        height: 45px;
        text-align: left;
        border-bottom: 1px solid #dcdcdc;
    }

    .in-table1 div {
        line-height: 45px;
        width: 48%;
        display: inline-block;
    }

    .in-tabOne1 {
        border-right: 1px solid #dcdcdc;
    }

    .in-tabOne1 h2 {
        font-weight: inherit;
        padding-left: 13px;
        color: #dcdcdc;
        margin: 0;
        font-size: 16px;
        display: inline-block;
    }

    .in-tabTow1 h2 {
        font-weight: inherit;
        padding-left: 13px;
        color: #dcdcdc;
        margin: 0;
        font-size: 16px;
        display: inline-block;
    }

    .in-tabOne1 h2 span {
        margin-left: 8px;
        color: black;
    }

    .in-tabTow1 h2 span {
        margin-left: 8px;
        color: black;
    }

    .in-tel1 {
        height: 45px;
        text-align: left;
        border-bottom: 1px solid #dcdcdc;
    }

    .in-tel1 h2 {
        line-height: 45px;
    }

    .in-tel1 h2 {
        font-weight: inherit;
        padding-left: 13px;
        color: #dcdcdc;
        margin: 0;
        font-size: 16px;
        display: inline-block;
    }

    .in-tel1 h2 span {
        margin-left: 8px;
        color: black;
    }

    .list1 {
        width: 70%;
        padding-bottom: 30px;
        border: 1px solid #dcdcdc;
        box-shadow: 0 0 10px #dcdcdc;
        border-radius: 10px;
        flex-wrap: nowrap;
        margin-top: 20px;
        margin-left: 50px;
    }

    .list_p1 {
        text-align: center;
        height: 60px;
        width: 100%;
        line-height: 60px;
        font-size: 20px;
        color: #a4a7af;
        background-color: #f2f2f2;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
    }

    .heji1 {
        margin-top: 50px;
        margin-left: 20%;
        color: rgba(0, 0, 0, 0.68);
    }

    .heji1 span {
        display: inline-block;
        width: 150px;
        border-bottom: 1px solid black;
        text-align: center;
        margin-left: 20px;
    }
</style>
<script>

  export default {
    data() {
      return {
          mailAddress:'',
          pic:'',
          orderType:'',
        active: true,
        Data: '',
        patientId: 0,
          levelSelected:'',
        chargeList: [],
        name: '',
        tablevalue: [],
          patientBaseEntity:{},
        totalCost: '',
        gift: '',
          lookid:'',
          userLevelType: [{
              value: '是',
              label: '是'
          }, {
              value: '否',
              label: '否'
          }],
          payerId:0,
          Jname: '',
          options:[],
          isPayer:false,
          payerQuota:0
      }
    },
    mounted: function () {
        if(this.$route.query.data != undefined){
            let datalist = JSON.parse(this.$route.query.data);
            this.Data = datalist.orderNumber;
            this.orderType = datalist.orderType;
            this.patientId = datalist.patientId;

          // 查询代付人
          this.$axios({
            url: '/api/user/userIsStock/' + this.patientId,
            method: 'GET',
          }).then(res => {
            this.options = res.data.data;
          }).catch(err => {
            this.$message.error('数据获取失败');
          });
        }
        if (this.$route.query.Data!=undefined){
            this.lookid= this.$route.query.Data;
            let lookid = this.lookid;
            this.Data = lookid;
            console.log(this.lookid);
        }
        this.getinfo();
    },
    methods: {
      getinfo: function () {
        this.$axios({
          url: '/api/order/' + this.Data,
          method: 'GET',
        }).then(res => {
          this.patientBaseEntity = res.data.data.patientBaseEntity
           this.totalCost = res.data.data.totalCost;
          this.gift = res.data.data.gift;
           this.mailAddress=res.data.data.mailAddress
          this.tablevalue = res.data.data.recipeResponseList;
            // for (var k=0;k<tabdata.length;k++){
            //     tabdata[k].medicineName='汤方'+[k+1];
            //     this.tablevalue.push(tabdata[k])
            // }
        console.log(this.tablevalue)

        })
      },
        changeValue(value) {
            this.payerId = value.split('@')[0]

            this.payerQuota = value.split('@')[1];

//            alert(this.payerId + 'dsad' + this.payerQuota)
        },
      change:function () {
          this.isPayer = !this.isPayer;
          if(this.isPayer){

          }
      },
      pay: function (paymentType) {
          if(paymentType != 4){
              if (this.levelSelected=='是' && this.mailAddress!=''){
                  let info = {
                      mail:1,
                      mailAddress:this.mailAddress,
                      orderNumber:this.Data,
                      paymentType:paymentType
                  };
                  this.$axios({
                      url:'/api/order/pay',
                      method:'POST',
                      data:info
                  }).then(res=>{
                      this.$message({
                          type:'success',
                          message:'支付成功，药品待邮寄'
                      })
                      this.$router.push({path: "./charge_list"})
                  }).catch(err=>{
                      console.log(err.data);
                  })
              }else if ((this.levelSelected==''||this.levelSelected=='否') && this.mailAddress=='') {
                  let info2 = {
                      mail:0,
                      orderNumber:this.Data,
                      paymentType:paymentType
                  };
                  this.$axios({
                      url: '/api/order/pay',
                      method: 'POST',
                      data:info2
                  }).then(res => {
                      if (res.data.code == 200) {
                          this.$message({
                              type: 'success',
                              message: '支付成功'
                          })
                          this.$router.push({path: "./charge_list"})
                      } else {
                          this.$message({
                              type: 'success',
                              message: '支付失败'
                          })
                      }
                  }).catch(err => {
                      console.log(err.data);
                  })
              }
          }
          else if(paymentType == 4){
//              alert(this.payerId)
              if(this.payerId == ''){
                  this.$message({
                      type:'error',
                      message:'代付人不能为空！'
                  })
                  return;
              }
              // if(this.payerQuota < this.totalCost){
              //     this.$message({
              //         type:'error',
              //         message:'代付人额度不足！'
              //     })
              //     return;
              // }

              let info3 = {
                  mail:0,
                  orderNumber:this.Data,
                  paymentType:paymentType,
                  payerId: this.payerId
              };
              this.$axios({
                  url: '/api/order/pay',
                  method: 'POST',
                  data:info3
              }).then(res => {
                  if (res.data.code == 200) {
                      this.$message({
                          type: 'success',
                          message: '支付成功'
                      })
                      this.$router.push({path: "./charge_list"})
                  } else {
                      this.$message({
                          type: 'success',
                          message: '支付失败'
                      })
                  }
              }).catch(err => {
                  console.log(err.data);
              })
          }
      },
    }
  }
</script>



// WEBPACK FOOTER //
// chargeDetail.vue?d19f1cc0